import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  PAYMENT_WITH_LIVE_STOCKS,
  UPDATE_ORDERGROUP,
} from "../../../graphql/order/mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_ORDERGROUPS_DETAIL } from "../../../graphql/order/query";
import OrderGroupDetail from "./OrderGroupDetail";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Container, Row, Col, Button } from 'react-bootstrap';
// import { LinkContainer } from 'react-router-bootstrap';

export default function CompletedPayment() {
  // const history = useHistory();
  // const [newOrderGroup, setNewOrderGroup] = useState();

  // const [updateOrderGroup, { loading: updateOrderGroupLoading }] =
  //   useMutation(UPDATE_ORDERGROUP);

  // const [getOrderData, { data: orderGroup, loading: _orderLoading }] =
  //   useLazyQuery(GET_ORDERGROUPS_DETAIL, { fetchPolicy: "cache-and-network" });

  // const customerJsonData = JSON.parse(localStorage.getItem("CUSTOMER_DATA"));

  // useEffect(() => {
  //   if (history.location.search) {
  //     // Parse the URL search parameters
  //     const searchParams = new URLSearchParams(history.location.search);
  //     const parameData = Object.fromEntries(searchParams.entries());

  //     console.log("parameData:--->", parameData);

  //     updateOrderGroups(parameData);
  //     getLiveOrder(parameData.orderGroupId);
  //   }
  // }, [history.location.search]);

  // useEffect(() => {
  //   if (orderGroup) {
  //     setNewOrderGroup(orderGroup?.orderGroup);
  //   }
  // }, [orderGroup]);

  // if(_orderLoading) return <LoadingSpinner />

  // ໄປຕໍ່: ໜ້ານີ້ຖືກສະແດງໃນ iframe ຂອງໜ້າຊຳລະ (ConfirmPaymentV2) →
  // ບອກໜ້າແມ່ໃຫ້ປິດ modal ແລ້ວໄປຂັ້ນປ້ອນຂໍ້ມູນຈັດສົ່ງ. ຖ້າເປີດເຕັມໜ້າ → ຍ້ອນກັບ.
  const handleContinue = () => {
    if (typeof window !== "undefined" && window.parent && window.parent !== window) {
      window.parent.postMessage({ type: "PHAPAY_PAYMENT_DONE" }, "*");
    } else {
      window.history.back();
    }
  };

  return (
    <Container fluid className="d-flex min-vh-100 flex-column align-items-center justify-content-center px-4 py-5">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{ height: '20em', width: '20em' }}>
            <img src="https://i.pinimg.com/originals/32/b6/f2/32b6f2aeeb2d21c5a29382721cdc67f7.gif" style={{width:"100%", height:'100%',objectFit:'contain'}} />
          </div>
          <h1 className="mt-4 text-3xl fw-bold text-dark">ສຳເລັດທຸລະກຳແລ້ວ</h1>
          <p className="mt-3 text-muted">ການຈ່າຍເງິນຂອງທ່ານສຳເລັດແລ້ວ. ຂອບໃຈທີ່ນຳໃຊ້ບໍລິການຂອງພວກເຮົາ.</p>
          <div className="mt-4">
            <Button
              onClick={handleContinue}
              size="lg"
              style={{
                background: "linear-gradient(45deg, #0e2a47 0%, #00c0d0 100%)",
                border: "none",
                fontWeight: 700,
                padding: "0.6em 2.5em",
                borderRadius: "0.6em",
              }}
            >
              ໄປຕໍ່
            </Button>
          </div>
    </Container>
  );
}

function CircleCheckIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}
